export interface UserData {
	firstName?: string;
	lastName?: string;
	email?: string;
}

/**
 * Accessor function for user table columns that enables global filtering
 * @param row - Table row data containing user information
 * @returns Searchable string for global filter
 */
export const userTableAccessorFn = (row: UserData): string => {
	return `${row.firstName}|||${row.lastName}|||${row.email}|||${row.firstName} ${row.lastName}`.toLowerCase();
};
